import React from "react";
import '../App.css';
import styles from "../styles/level1.module.css"

const home = () => {
  return (
    <div className={styles.container}>

    <main className={styles.main}>
      <h1 className={styles.title}>
        About This Curriculum </h1> <br></br> 
       <p className={styles.description}> 
       Learning Objectives <br></br> 
          1. To develop an introductory understanding of the computer science language (Python) to be used in further studies and robotics curriculum <br></br> 
          2. To incorporate the data collected from the environmental sensors and garden harvesting data into foreseeing trends, understanding environmental impacts, and furthering awareness on the importance of nature
       </p>
        
        <p className={styles.description}>
        What You Will Learn <br></br>
        The Plant the Code curriculum is designed to offer an introduction to the basics of computer science, specifically in Python. The curriculum directly coincides with the data collected from the Andrew Hamilton elementary school garden into finding a fun and first-hand witnessing of the trendlines and impact of the garden planting.
        </p>
        <p className={styles.description}>
        How to Start <br></br>
        Use the curriculum guide to go from Levels 0 to 6 in the Blockly curriculum!
        </p>
        <p className={styles.description}>
        What's Next? <br></br>
        Once you have finished Levels 0 to 6 in the Plant the Code curriculum, then you are now a beginner coder! :)
        </p>  
      
    </main>
  </div>
  );
}
  
export default home;